import { People } from "@styled-icons/material/People"
// import { Leaderboard } from '@styled-icons/material/Leaderboard'
import { BusinessCenter } from "@styled-icons/material/BusinessCenter"
import { AttachMoney } from "@styled-icons/material/AttachMoney"
import { Assessment } from "@styled-icons/material/Assessment"
// import { Search } from "@styled-icons/material/Search"
// import { Notifications } from "@styled-icons/material/Notifications"
import { CorporateFare } from "@styled-icons/material"
import { SupportAgent } from "@styled-icons/material/SupportAgent"
import { NotificationsActive } from "@styled-icons/material/NotificationsActive"
import { Forum } from "@styled-icons/material/Forum"

const SidebarItems = [
  {
    name: "Dashboard",
    route: "/dashboard",
    icon: Assessment,
    key: "dashboard",
    rolesAllowed: ["ADMIN", "LOCAL_ADMIN", "SUPER_ADMIN"],
  },
  {
    name: "Usuarios",
    route: "/users",
    icon: People,
    key: "users",
    rolesAllowed: ["ADMIN", "LOCAL_ADMIN", "SUPER_ADMIN"],
  },
  {
    name: "Organizaciones",
    route: "/organizations",
    icon: BusinessCenter,
    key: "orgs",
    rolesAllowed: ["LOCAL_ADMIN", "BUSINESS_ADMIN", "ADMIN", "SUPER_ADMIN"],
  },
  {
    name: "Pagos",
    route: "/payments",
    icon: AttachMoney,
    key: "payments",
    rolesAllowed: ["ADMIN", "LOCAL_ADMIN", "SUPER_ADMIN"],
  },
  // {
  //   name: "Search",
  //   route: "/search",
  //   isFooter: true,
  //   icon: Search,
  //   key: "search",
  // },
  // {
  //   name: "Notifications",
  //   route: "/notifications",
  //   isFooter: true,
  //   icon: Notifications,
  //   bubble: true,
  //   key: "notifications",
  // },
  {
    name: "Plan Piloto",
    route: "/pilot-plan",
    icon: CorporateFare,
    key: "pilot-plan",
    rolesAllowed: ["ADMIN", "LOCAL_ADMIN", "SUPER_ADMIN"],
  },
  {
    name: "Comunicadores",
    route: "/communicators",
    icon: SupportAgent,
    key: "communicators",
    rolesAllowed: ["BUSINESS_ADMIN"],
    requiresMessagingAccess: true,
  },
  {
    name: "Messaging",
    route: "/messaging",
    icon: NotificationsActive,
    key: "messaging",
    rolesAllowed: ["BUSINESS_ADMIN", "COMMUNICATOR"],
    requiresMessagingAccess: true,
  },
  {
    name: "Admin Messaging",
    route: "/admin-messaging",
    icon: NotificationsActive,
    key: "admin-messaging",
    rolesAllowed: ["LOCAL_ADMIN"],
  },
  {
    name: "Admin Messaging",
    route: "/admin-messaging-history",
    icon: Forum,
    key: "admin-messaging-history",
    rolesAllowed: ["LOCAL_ADMIN"],
  },
  {
    name: "MessagingHistory",
    route: "/messaging-history",
    icon: Forum,
    key: "messaging-history",
    rolesAllowed: ["BUSINESS_ADMIN", "COMMUNICATOR"],
    requiresMessagingAccess: true,
  },
]

export default SidebarItems
